"use client";

import { Button } from "@/components/ui/button";
import {
  Form,
  FormControl,
  FormField,
  FormItem,
  FormMessage,
} from "@/components/ui/form";
import { Input } from "@/components/ui/input";
import LoadingButton from "@/components/ui/loading-button";
import { sharedRouteConfig } from "@/config/shared";
// import { LoadingDots } from "@/icons";
import { searchSchema } from "@/lib/validation/search";
import { zodResolver } from "@hookform/resolvers/zod";
import { useRouter } from "next/navigation";
import { useState } from "react";
import { useForm } from "react-hook-form";
import * as z from "zod";

type SearchFormValues = z.infer<typeof searchSchema>;

const VideoSearchBar = () => {
  const router = useRouter();
  const visible = true;
  const [loading, setIsLoading] = useState<boolean>(false);

  const defaultValues: Partial<SearchFormValues> = {
    query: "",
  };

  const searchForm = useForm<SearchFormValues>({
    resolver: zodResolver(searchSchema),
    mode: "onChange",
    defaultValues: defaultValues,
  });

  async function handleSearchAction() {
    if (searchForm.getValues("query") !== "") {
      setIsLoading(true);
      router.push(
        sharedRouteConfig.videoSearch + "/" + searchForm.getValues("query"),
      );
      setIsLoading(false);
    }
  }

  return (
    <>
      <div className="flex pb-4">
        {visible && (
          <Form {...searchForm}>
            <form
              // className={`mx-auto`}
              onSubmit={searchForm.handleSubmit(handleSearchAction)}
            >
              <div className="relative flex gap-2">
                <FormField
                  control={searchForm.control}
                  name="query"
                  render={({ field }) => (
                    <FormItem className="w-full max-w-md items-center">
                      <FormControl>
                        <Input {...field} />
                      </FormControl>
                      <FormMessage />
                    </FormItem>
                  )}
                />
                {!loading ? (
                  <Button type="submit" variant={"outline"}>
                    Search
                  </Button>
                ) : (
                  <LoadingButton includeText />
                )}
              </div>
            </form>
          </Form>
        )}
      </div>
    </>
  );
};

export default VideoSearchBar;
